(ns app.front.guide-context
  "DOM scanning and utilities for guide context (NoVa chat → page element highlighting)."
  (:require [clojure.string :as str]))

(defn- visible-guide-element? [el]
  (and (nil? (.closest el "[hidden], [aria-hidden='true'], [inert]"))
       (pos? (.-length (.getClientRects el)))))

(defn- guide-element-data [el]
  (let [id          (.getAttribute el "data-guide-id")
        label       (.getAttribute el "data-guide-label")
        description (.getAttribute el "data-guide-description")]
    (when (and (not (str/blank? id))
               (not (str/blank? label)))
      (cond-> {:id    id
               :label label}
        (not (str/blank? description)) (assoc :description description)))))

(defn collect-guide-elements
  "Scans the visible page DOM for [data-guide-id] elements and returns
   a vector of {:id ... :label ... :description ...} maps to send
   to the LLM as context. Hidden/inert elements and malformed entries are skipped."
  []
  (->> (.querySelectorAll (.-body js/document) "[data-guide-id]")
       array-seq
       (filter visible-guide-element?)
       (keep guide-element-data)
       (reduce (fn [{:keys [seen-ids elements] :as result} {:keys [id] :as element}]
                 (if (contains? seen-ids id)
                   result
                   {:seen-ids (conj seen-ids id)
                    :elements (conj elements element)}))
               {:seen-ids #{}
                :elements []})
       :elements))

(defn collect-guide-page-description
  "Returns the page-level description from a visible [data-guide-page-description]
   attribute if present on any element, or nil."
  []
  (some->> (.querySelectorAll (.-body js/document) "[data-guide-page-description]")
           array-seq
           (filter visible-guide-element?)
           first
           (#(.getAttribute % "data-guide-page-description"))))
